import React from 'react';

const TripListing = {
  title: 'Trip Listing',
  items: [
    {
      header: 'Trip Listing - Pricing',
      content: (
        <div>
          <p>Please be clear about what is and what isn’t included in your listed price. Some Local Experts prefer lowering their listed prices by not including some fees. However, we highly recommend including everything travelers may need to pay for in the listed price. </p>
          <p>Please choose one of the following price conditions:</p>
          <ul>
            <li><p>All-inclusive (Food, transportation fares and admission fees included)</p></li>
            <li><p>Food excluded</p></li>
          </ul>
          <p>When choosing the price condition, you will see different suggested price ranges. These ranges are considered affordable for travelers. However, it’s all up to what you provide on your trip. </p>
        </div>
      )
    }
  ]
};

export default TripListing;
